import Card from "../../components/base/Card";
import Button from "../../components/base/Button";

interface Props {
    onFinish: () => void;
}

export default function CompletedScreen({ onFinish }: Props) {
    return (
        <div className="min-h-screen bg-gradient-to-br from-purple-50 to-indigo-100">
            <div className="max-w-2xl mx-auto px-4 py-12">
                <Card className="text-center p-8">
                    <h1 className="text-3xl font-bold text-gray-900 mb-4">
                        AI Interview Completed!
                    </h1>
                    <p className="text-lg text-gray-600 mb-8">
                        Excellent work! You've successfully completed the voice interview simulation.
                    </p>
                    <Button onClick={onFinish} size="lg">
                        Return to Dashboard
                    </Button>
                </Card>
            </div>
        </div>
    );
}
